import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Table,
  Tbody,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useGetCodeYellowTargetedProvidersWithAvailability } from "../../api/CodeYellowApi";
import { TargetedProvidersColSettings } from "./TargetedProvidersColSettings";
import { TargetedProvidersCaption } from "./TargetedProvidersCaption";
import TargetedProvidersRow from "./TargetedProvidersRow";

const TargetedProvidersModal: React.FC<{
  codeYellowId: string | null;
  isOpen: boolean;
  onClose: () => void;
  showSwitch?: boolean;
}> = ({ codeYellowId, isOpen, onClose, showSwitch = true }) => {
  const { data: targetedProvidersWithAvailability } =
    useGetCodeYellowTargetedProvidersWithAvailability(codeYellowId);

  const modalWidth = showSwitch ? "400px" : "300px";

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay bg="#14153233" />
      <ModalContent
        borderRadius="24px"
        bgColor="darkBlue2.800"
        sx={{ width: modalWidth }}
        my="auto"
        mx="auto"
      >
        <ModalBody minW="100%" px={0}>
          <Table variant="unstyled" size="sm" height={"100%"} minH="100%">
            <TargetedProvidersCaption />
            <TargetedProvidersColSettings showSwitch={showSwitch}/>
            <Thead>
              <Tr>
                <Th>Provider list</Th>
                <Th textAlign="right">Opted in</Th>
              </Tr>
            </Thead>
            <Tbody>
              {(targetedProvidersWithAvailability?.targetedProviders ?? []).map(
                (provider) => (
                  <TargetedProvidersRow
                    key={provider.id}
                    provider={provider}
                    codeYellowId={codeYellowId}
                    showSwitch={showSwitch}
                  />
                ),
              )}
            </Tbody>
          </Table>
        </ModalBody>
        <ModalFooter px="3">
          <Button
            variant="outline"
            color="white"
            onClick={onClose}
            w="100%"
            borderRadius="8px"
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TargetedProvidersModal;